import { useEntityChangeSubscr } from '@/common/entityChange/EntityChangeContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { TestResList } from '../testRes/TestResList';

export const TestResultsTab = ({ testId }) => {
  const rsrc = useRsrc();
  const [runs, setRuns] = useState([]);
  const [selectedRunId, setSelectedRunId] = useState('');
  const { refreshTrigger } = useEntityChangeSubscr('skdr', 'RUN');

  useEffect(() => {
    rsrc
      .rows('skdr', 'RUN', { query: 'ENTITY_RUNS', replaceParams: { entity: 'TEST', entityId: testId } })
      .then((res) => {
        setRuns(res);
        setSelectedRunId(res.length > 0 ? res[0].id : '');
      });
  }, [testId, refreshTrigger]);

  return (
    <>
      {runs.length > 0 && (
        <FormControl size="small" sx={{ minWidth: 280, mb: 2 }}>
          <InputLabel>Run</InputLabel>
          <Select value={selectedRunId} label="Run" onChange={(event) => setSelectedRunId(event.target.value)}>
            {runs.map((run) => (
              <MenuItem key={run.id} value={run.id}>
                {new Date(run.verStartInstant).toLocaleString()}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {selectedRunId && <TestResList runId={selectedRunId} />}
    </>
  );
};
